import config from "@/utils/config"
import {
	printObj
} from "@/utils/debug"

/**
 * 国内管理员权限
 * @param {Object} value
 */
export function getRoleProd(value) {
	// printObj(process.env)
	//测试版开
	if(process.env.NODE_ENV === 'development'){
		return '系统管理员'
	}
	if (value === "true") {
		return '系统管理员'
	}
	return ''
}

/**
 * 海外管理员权限
 * @param {Object} value
 */
export function getRoleAbroad(value) {
	//测试版开
	if(process.env.NODE_ENV === 'development'){
		return 'Super Admin'
	}
	if (value === "true") {
		return 'Super Admin'
	}
	return ""
}
